import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { UserVM } from '../../../core/view-models/userVM';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private _baseUrl = `${environment.apiURL}/api`;

  constructor(private http: HttpClient) { }

  getUsers(isTable = false){
    return this.http.get<any>(`${this._baseUrl}/user/GetAll/${isTable}`);
  }

  isUserInRole(id: string, role: string){
    return this.http.get<any>(`${this._baseUrl}/user/${id}/isInRole/${role}`);
  }

  getUserById(id: string){
    return this.http.get<any>(`${this._baseUrl}/user/${id}`);
  }
  getUserIdByUsername(username: string) {
    //return this.http.get<any>(`${this._baseUrl}/user/GetIdByUserName/${username}`);
    return this.http.get<any>(`${this._baseUrl}/user/username/${username}`);

  }
  getSpecifiUserType(type: string){
    return this.http.get<any>(`${this._baseUrl}/user/specific/${type}`);
  }

  checkIfUsernameExists(user, type: string){
    // debugger
    if(type == "update")
      return this.http.get<any>(`${this._baseUrl}/user/checkUsername/${type}/${user.userName}?id=${user.id}`);
    else 
      return this.http.get<any>(`${this._baseUrl}/user/checkUsername/${type}/${user.userName}`);

  }

  addUser(userVM: any){
    // // console.log(userVM.password);
    const form = new FormData();
    form.append("firstName", userVM.firstName);
    form.append("lastName", userVM.lastName);
    form.append("email", userVM.email);
    form.append("userName", userVM.userName);
    form.append("Password", userVM.password);
    form.append("confirmPassword", userVM.confirmPassword);
    form.append("image", userVM.image);
    form.append("nationality", userVM.nationality);
    form.append("sapSalesManCode",userVM.SAPSalesManCode?userVM.SAPSalesManCode.toString():'');
    form.append("userType", userVM?.userType.toString());

    for (const index in userVM.roleIds) 
    {
      form.append(`rolesIds[${index}]`,JSON.stringify(userVM.roleIds[index]));
    }

    for (const index in userVM.factories) 
      {
        form.append(`factories[${index}]`,JSON.stringify(userVM.factories[index]));
      }

    
    
    return this.http.post<any>(`${this._baseUrl}/user/add`,form);
  }
  
  updateUser(id: string, userVM: any){
    // debugger
    const form = new FormData();
    form.append("id", id);
    form.append("firstName", userVM.firstName);
    form.append("lastName", userVM.lastName);
    form.append("email", userVM.email);
    form.append("userName", userVM.userName);
    form.append("userCode", userVM.userCode);
    form.append("userType", userVM?.userType.toString());
    form.append("sapSalesManCode",userVM.SAPSalesManCode?userVM.SAPSalesManCode.toString():'');
    if(userVM.password != null && userVM.password.length>0){
      form.append("password", userVM.password);
    } 
    // else {
    //   form.append("password", "");
    // }
    if(userVM.confirmPassword != null && userVM.confirmPassword.length>0){
      form.append("confirmPassword", userVM.confirmPassword);
    } 
    // else {
    //   form.append("confirmPassword", "");
    // }
    form.append("image", userVM.image);
    form.append("nationality", userVM.nationality);

      for (const index in userVM.roleIds) 
        {
          form.append(`rolesIds[${index}]`,JSON.stringify(userVM.roleIds[index]));
        }
    
        for (const index in userVM.factories) 
          {
            form.append(`factories[${index}]`,JSON.stringify(userVM.factories[index]));
          }
    return this.http.patch<any>(`${this._baseUrl}/user/edit/${id}`,form);
  }

  deleteUser(id: string){
    return this.http.delete<any>(`${this._baseUrl}/user/delete/${id}`);
  }

  deleteUsers(ids: string[]){
    return this.http.delete<any>(`${this._baseUrl}/user/delete/range`, {body: ids});
  }

  checkPermission(userId: string, permissionName: string){
    return this.http.get<any>(`${this._baseUrl}/user/checkpermission/${userId}?permissionName=${permissionName}`);
  }

  activateDeactivateUser(userId: string, status: boolean){
    return this.http.post<any>(`${this._baseUrl}/user/ChangeStatus/${userId}/${status}`,null);
  }


  getPaginatedUsers(pageIndex = 0, pageSize = 10, pagination = true, criteria = null, isActive = -1,customerId = null,userType=-1,userId=null,customerGroupId=null){
    //console.log((`${this._baseUrl}/user/paginated/${isActive}?PageIndex=${pageIndex}&PageSize=${pageSize}&Pagination=${pagination}${criteria != null ? "&Criteria="+criteria : ""}${customerId !=null ? "&customerId="+customerId:""}${userId !=null ? "&userId="+userId:""}${userType!=null?"&userType="+userType:""} `));
    return this.http.get<any>(`${this._baseUrl}/user/paginated/${isActive}?PageIndex=${pageIndex}&PageSize=${pageSize}&Pagination=${pagination}${criteria != null ? "&Criteria="+criteria : ""}${customerId !=null ? "&customerId="+customerId:""}${userId !=null ? "&userId="+userId:""}${customerGroupId!=null?"&customerGroupId="+customerGroupId:""}${userType!=null?"&userType="+userType:""} `);
  }

  getUsersForRoleDriver(){
    return this.http.get<any>(`${this._baseUrl}/user/driversList`);
  }

  getSalesAgentUsersList(){
    return this.http.get<any>(`${this._baseUrl}/user/salesAgentsList`);
  }

  getSAPSalesPersonsList(){
    return this.http.get<any>(`${this._baseUrl}/user/sapSalesPersonsList`);
  }

  updateUserLanguage(userId: string, language: string){
    return this.http.post<any>(`${this._baseUrl}/User/UpdateLanguage/${userId}?language=${language}`,null);
  }

}
